import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ez-table-loading-state__content" }
const _hoisted_2 = {
  key: 0,
  class: "ez-table-loading-state__message"
}

import { LottieAnimation } from 'lottie-web-vue';
import loadingAnimation from '@/assets/loadingAnimation.json';

/**
 * EzTableのローディング状態表示コンポーネント
 * テーブル全体がローディング中であることを表示する
 */

/**
 * Props定義
 */
interface Props {
  /** ローディングメッセージ（省略可） */
  message?: string;
  /** カスタムCSSクラス（省略可） */
  customClass?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EzTableLoadingState',
  props: {
    message: { default: '' },
    customClass: { default: '' }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['ez-table-loading-state', _ctx.customClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(LottieAnimation), {
        "animation-data": _unref(loadingAnimation),
        loop: true,
        "auto-play": true,
        class: "ez-table-loading-state__animation"
      }, null, 8, ["animation-data"]),
      (_ctx.message)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.message), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})